import { render, staticRenderFns } from "./MonitoringFrequency.vue?vue&type=template&id=754468e1&scoped=true&"
import script from "./MonitoringFrequency.vue?vue&type=script&lang=js&"
export * from "./MonitoringFrequency.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringFrequency.vue?vue&type=style&index=0&id=754468e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754468e1",
  null
  
)

export default component.exports